export const getInitialState = (key) => {
  return {
    [key]: false,
    loading: false,
  }
}
